import React from 'react';
import Grid from '@material-ui/core/Grid';
import styled from 'styled-components';
import {
    withStyles,
    withWidth,
    Button,
} from "@material-ui/core";
import { connect } from "react-redux";
import SideDrawer from './../../logged_out/components/contactUs/SideDrawer';
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box';
import BoxButton from './../../shared/components/BoxButton';

import api from './../../shared/functions/api/';

const styles = (theme) => ({

});

const CallToActionsButtons = styled(Grid)`
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: 432px;

    .MuiButton-containedSecondary{
        height: 33px;
        font-family: Lato;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.21;
        letter-spacing: normal;
        text-align: center;
        text-transform: none;
        margin-top: 22px;
        margin-right: 8px;
        margin-left: 8px;
        
        color: #b08f6e;
        background-color: #ffffff;
        border: solid 1px #b6b8bc;

        box-shadow: none;
        color: #ffffff !important;
        border: solid 1px #b08f6e;
        background-color: #b08f6e;

        width: 130px;
    }

    .MuiButton-containedSecondary:disabled{
        border: solid 1px #ccced3;
        background-color: #ccced3;
    }
`;

const textStyle = {
    fontFamily: 'Lato',
    fontSize: '13px',
    fontWeight: '500',
    fontStretch: 'normal',
    fontStyle: 'normal',
    letterSpacing: 'normal',
    color: '#6d7279',
};

const APIRegistrationDrawer = ({
    sideDrawerOpen,
    closeDrawer,
    authUser,
    openEmailDialog,
    openRegisterDialog,
    pushMessageToSnackbar,
    history,
}) => {

    React.useEffect(() => {
        if(sideDrawerOpen && authUser && authUser.api_allow){
            history.push(`/my-account/api`);
        }
    }, [authUser, sideDrawerOpen])

    const [requestApiAccessMessage, setMessage] = React.useState('');

    const submitRegistration = async () => {
        try {
            const res = await api.post(`/register-api-access`, {
                requestApiAccessMessage,
            });

            setMessage('')

            pushMessageToSnackbar({
                text: "Thanks for requesting your API Link access!"
            });

            closeDrawer();
        } catch (err) {
            console.log(err)
        }
    }

    return (<SideDrawer
        title={<div style={{
            fontSize: '18px',
            fontStyle: 'italic',
            fontWeight: '600'
        }}>HENIG API LINK REGISTRATION</div>}
        open={sideDrawerOpen}
        onClose={closeDrawer}
    >
        <p style={textStyle}>
            API link gives you instant access to our full range of stock with a complete set of data.
            You also get links to our images, videos and 3D videos.
            The links support both CSV downloads and a modern secure REST API with a JSON response format.
        </p>

        {!authUser && <p style={textStyle}>
            If you are already a Henig Diamonds customer, please login first, or register for an account
        </p>}
        {authUser && <>
            <p style={textStyle}>
                Please let us know how you intend to use the link, and we will get in touch promptly to get you up and running in no time.
            </p>
            <Box mt={3}>
                <TextField placeholder="Start typing your message..." fullWidth multiline rows={10} value={requestApiAccessMessage} onChange={e => setMessage(e.target.value)} />
            </Box>
            <BoxButton
                style={{ position: 'absolute', bottom: 0, left: 0 }}
                labelStyle={{ width: 'auto' }}
                onClick={() => submitRegistration()}
                text={'SUBMIT REGISTRATION'}
                iconPath="/images/Screenshot 2020-11-07 at 10.43.49.jpg"
            />
        </>}

        {!authUser && <CallToActionsButtons style={{ justifyContent: 'flex-start' }}>

            <Button
                type="button"
                variant="contained"
                color="secondary"
                onClick={() => openEmailDialog()}
            >
                Login
            </Button>

            <Button
                type="button"
                variant="contained"
                color="secondary"
                onClick={() => openEmailDialog({initialValues: {requestApiAccess: true}})}
            >
                Register
            </Button>
        </CallToActionsButtons>}

    </SideDrawer>
    );
}

export default connect(
    (state) => ({
        authUser: state.auth.user,
    })
)(withWidth()(withStyles(styles, { withTheme: true })(APIRegistrationDrawer)));